var map = {
	"./0/icon-birthday.png": 9525,
	"./0/icon-coin.png": 29947,
	"./0/icon-country.png": 42602,
	"./0/icon-diamond.png": 44756,
	"./0/icon-gender.png": 78827,
	"./0/icon-nickname.png": 62647,
	"./0/icon-profession.png": 20346,
	"./0/icon-quest.png": 83832,
	"./0/icon-spins.png": 16246,
	"./0/icon-star.png": 98522,
	"./0/icon-telegram.png": 31898,
	"./0/icon-usdt.png": 21302,
	"./0/icon-vip.png": 14206,
	"./0/icon/icon-biography.png": 98638,
	"./0/icon/icon-fan.png": 82065,
	"./0/icon/icon-fj.png": 96675,
	"./0/icon/icon-lucky.png": 42840,
	"./0/icon/icon-meta.png": 55606,
	"./0/icon/icon-q.png": 10712,
	"./0/icon/icon-task.png": 37222,
	"./0/icon/icon-tokenomics.png": 71866,
	"./0/icon/icon-tp.png": 90269,
	"./0/icon/icon-vip.png": 43062,
	"./0/icon/icon-x.png": 17344,
	"./0/icon/icon-youtube.png": 13160,
	"./0/pass/icon-fan.png": 65496,
	"./0/pass/icon-task.png": 42743,
	"./0/pass/icon-vip.png": 63004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3183;